import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 9: Perfectly Imperfect</h1>
          <p className="white"><b>How to tell perfection to suck it</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Take a big-ass breath.
            </li>
            <li>Think to yourself, “Thank you for trying to protect me from disappointment or shame, but I no longer need you to do that. I no longer value perfection. Instead, I value authenticity and growth, and I accept myself and all of my awesome and unique imperfections.”
            </li>
            <li>If you made a mistake or did not achieve the ‘perfect’ results you were hoping for, ask yourself:
              <ul>
                <li style={{listStyleType:"none"}}>Did I try?</li>
                <li style={{listStyleType:"none"}}>Did I do the best I could at the time?</li>
                <li style={{listStyleType:"none"}}>Did I learn anything?</li>
              </ul>
            </li>
            <li>Let. It. Go.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter9.js